import { TimelineLite, Expo } from 'gsap/TweenMax';
import MorphSVGPlugin from '@/assets/lib/gsap-bonus/MorphSVGPlugin'; //eslint-disable-line

import { qs } from '@/scripts/utils';

export const numberIn = (el) => {
  const tl = new TimelineLite({ paused: true });

  const d0 = qs('[js-path="d0"]', el);
  const dn = qs('[js-path="dn"]', el);
  const n0 = qs('[js-path="n0"]', el);
  const nn = qs('[js-path="nn"]', el);

  tl
    .set(el, { autoAlpha: 1 })
    .set(d0, { autoAlpha: 0.1 })
    .set(dn, { autoAlpha: 0.1 })
    .to(d0, 1.5, {
      morphSVG: n0,
      autoAlpha: 1,
      ease: Expo.easeOut,
    }, 0)
    .to(dn, 1.5, {
      morphSVG: nn,
      autoAlpha: 1,
      ease: Expo.easeOut,
    }, 0);

  return tl;
};

export const numberOut = (el) => {
  const tl = new TimelineLite({ paused: true });

  tl
    .to(el, 1, {
      autoAlpha: 0,
      ease: Expo.easeOut,
    });

  return tl;
};



// WEBPACK FOOTER //
// ./src/scripts/timelines/numberTransitions.js